import React from "react";
import logo from "assets/img/zarapreowned.svg";
import { translate } from "application/functions";

const ErrorMessage = (props) => {
  return (
    <>
      <div className="form__form-app">
        <div className="form__form-header">
          <img className="form_form-logo" src={logo} alt="logo" />
        </div>
      </div>
      <div className="form__form-body-title error">{translate("server.error")}</div>
    </>
  );
};

export default ErrorMessage;
